/**
 * 收集散落在各个项目(lit, astro, theme app, 第三方插件)中的全局事件
 * 既作为函数化的封装(多处调用时方便修改逻辑)
 * 也作为文档依据
 */
class GlobalDocumentEvent {
  /**
   * 打开登录弹窗
   * @param { object } loginParams - 登录事件参数
   * @param { string } loginParams.returnUrl - 登录后的跳转地址, 第一优先级
   * @param { string } loginParams.source - 登录来源(埋点事件用)
   * 默认规则(无 returnUrl)下, /cart 和 /pages/xtool-creators-club 和 checkout 回到原页面
   * 其他情况跳转个人中心, 个人中心具体板块可在 setting 中配置
   * 留在原地请自行配置 returnUrl 为 location.href
   * 由于要从 multipass login 跳转, 所以无法实现回到原页面的原位置
   */
  static openLoginModal(loginParams) {
    const OPEN_LOGIN_MODAL_EVENT_NAME = `astro::custom::directive::openLogin`;
    const customerEvent = new CustomEvent(OPEN_LOGIN_MODAL_EVENT_NAME, {
      detail: {
        ...loginParams
      }
    });
    document.dispatchEvent(customerEvent);
  }
}
